export enum PendingActions {
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_FAVORITES = 'ADD_TO_FAVORITES',
  ADD_TO_COMPARISON = 'ADD_TO_COMPARISON'
}
